export const SET_QUERY_FILTERS = 'SET_QUERY_FILTERS'
export const SET_REFERENCE_QUERY_FILTERS = 'SET_REFERENCE_QUERY_FILTERS'
export const SET_QUERY_INDEX = 'SET_QUERY_INDEX'
export const SET_RESET_STATE = 'SET_RESET_STATE'
